module.exports = __webpack_public_path__ + "static/media/xmlb.3034b1b9.png";